import { render, staticRenderFns } from "./CustomLottie.vue?vue&type=template&id=4ced2ad6&scoped=true&"
import script from "./CustomLottie.vue?vue&type=script&lang=js&"
export * from "./CustomLottie.vue?vue&type=script&lang=js&"
import style0 from "./CustomLottie.vue?vue&type=style&index=0&id=4ced2ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced2ad6",
  null
  
)

export default component.exports